module.exports = __webpack_public_path__ + "static/livechat-7aa879c52d0212d649966a6cf02fd6eb.png";